export function traverse<T extends { children: T[] }>(nodes: T[], consumer: (node: T, parent?: T) => void, parent?: T) {
  nodes.forEach((node) => {
    consumer(node, parent);
    traverse(node.children, consumer, node);
  });
}
